'use client';

import { useEffect } from 'react';
import useAuthStore from '@auth/store/useAuthStore';
import Intercom, { boot } from '@intercom/messenger-js-sdk';

export default function IntercomProvider() {
    const {user} = useAuthStore();
  useEffect(() => {
    if (user) {
        Intercom({
            app_id: 'zbk7c7c0',
            name: user.name,
            email: user.email,
        });
    }
  }, []);

  return null;
}